// @ts-nocheck

import React from 'react';
import { connect } from 'react-redux';
import Head from 'react-helmet';
import { areaUtils_getBestArea } from 'app/shared/utils/areaUtils';
import Button from 'app/shared/core/Button';
import Container from 'app/shared/core/Container';
import Input from 'app/shared/core/Input';
import Linker from 'app/shared/modules/Linker';
import NotificationActions from 'app/shared/flux/actions/NotificationActions';
import ErrorActions from 'app/shared/flux/actions/ErrorActions';
import Row from 'app/shared/core/Row';
import Section from 'app/shared/modules/Section';
import Spinner from 'app/shared/modules/Spinner';
import stringHelper from 'app/shared/utils/stringHelper';
import Title from 'app/shared/modules/Title';
import validator from 'app/shared/utils/validator';

import './style.scss';
import { logError } from '@zg-rentals/log-error';

class UnsubscribePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      email: this.props.email || '',
      errorMsg: null,
      success: false,
    };
  }

  componentDidMount() {
    const urlQueryParams = stringHelper.getUrlQueryParams();
    let email;

    if (urlQueryParams) {
      email = urlQueryParams.email;
      this.setState({ email });
    }
  }
  serverRouteWillMount(reactContext) {
    const dispatch = reactContext.store.dispatch;
    const query = reactContext.state.query;
    const email = query.email;

    return dispatch(NotificationActions.email.getUserSubscriptions(email)).catch((error) => {
      dispatch(
        ErrorActions.errorHandler({
          error,
          errorLocation: 'component.unsubscribePage.serverRouteWillMount',
          errorClass: 'notificationActions',
        }),
      );
    });
  }
  verifyEmail = () => {
    let verity = 1;
    const validEmail = validator.email(this.state.email);

    if (!validEmail.isValid) {
      this.setState({ errorMsg: validEmail.message });
      verity = 0;
    }

    return verity;
  };

  updateProfileRequest = () => {
    this.setState({
      loading: true,
      success: false,
    });
    this.props
      .dispatch(
        NotificationActions.email.updateUserSubscriptions(
          {
            stopListings: true,
            stopOther: true,
          },
          this.state.email,
        ),
      )
      .then(() => {
        this.setState({
          loading: false,
          success: true,
        });
      })
      .catch((err) => {
        logError({ error: err, context: 'Failed to update subscriptions.' });
        this.setState({
          loading: false,
        });
        throw err;
      });
  };

  handleEmailInput = (e) => {
    const emailInput = e.target.value;

    this.setState({ email: emailInput });
  };

  handleSubmitForm = (e) => {
    e.preventDefault();

    this.setState({
      errorMsg: null,
      success: false,
    });

    if (this.verifyEmail()) {
      this.setState(
        {
          loading: true,
        },
        () => {
          this.updateProfileRequest();
        },
      );
    }
  };

  render() {
    let mainContent;
    const areaResourceId = this.props.area.resourceId;

    if (this.state.loading) {
      mainContent = <Spinner className="Spinner-container" />;
    } else if (this.state.success) {
      mainContent = (
        <div>
          <div className="alert-box primary">Your subscription settings have been updated.</div>
          <Linker to={`/${areaResourceId}/apartments-for-rent`}>Search for rentals on hotpads.com</Linker>
        </div>
      );
    } else {
      mainContent = (
        <form>
          <Input
            help={this.state.errorMsg}
            hpxStyle={this.state.errorMsg ? 'error' : null}
            label="Email"
            maxLength={115}
            onChange={(e) => this.handleEmailInput(e)}
            required
            value={this.state.email}
          />
          <Row>
            <Button onClick={this.handleSubmitForm} disabled={this.state.loading}>
              {this.state.loading ? 'Loading...' : 'Unsubscribe'}
            </Button>
          </Row>
        </form>
      );
    }
    return (
      <div className="UnsubscribePage">
        <Head title="Unsubscribe | HotPads" />
        <Container>
          <Section>
            <Title size="lg">Don't want all that email?</Title>
          </Section>
          <div className="UnsubscribePage-headline">
            We try to keep everything we send you relevant - if you'd prefer not to receive content from HotPads,
            though, feel free to unsubscribe!
          </div>
          <div className="UnsubscribePage-content">{mainContent}</div>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    area: areaUtils_getBestArea(state),
    email: state.user.info.email,
  };
};

export default connect(mapStateToProps)(UnsubscribePage);
